import React from 'react'

import Picker from './components/Picker'
import SentryDebugBadge from './components/SentryDebugBadge';
import { StylesProvider } from '@mui/styles';

function App() {
  return (
    <StylesProvider injectFirst>
      <Picker />
      <SentryDebugBadge />
    </StylesProvider>
  );
}

export default App;
